export default __webpack_public_path__ + "/dist/images/setting-inactive.3ca3d8fdb620afd99d8b0ce81da1d24b.svg";